import { Navigate } from 'react-router-dom';
import Layout from '~/layout/DefaultLayout';
import { AuthContext } from '~/context/AuthProvider';
import { useContext } from 'react';

const ProtectedPage = () => {
  const { user } = useContext(AuthContext);

  // Only check if user is logged in - token validation happens server-side
  // Knox AUTO_REFRESH extends token expiry on API calls, and 401 responses
  // trigger logout via AuthProvider's error handling
  if (!user) {
    return <Navigate to='/login' replace />;
  }

  return <Layout />;
};

export default ProtectedPage;
